import { get, useFormState } from 'react-hook-form'

/**
 * Mensagem de erro da lista inteira (ex.: "Adicione ao menos uma ação"). O
 * resolver grava o erro de um field array em `root`, não na própria chave.
 */
export function ErroDaLista({ name }: { name: 'condicoes' | 'acoes' }) {
    const { errors } = useFormState({ name })
    const erro = get(errors, name)
    const mensagem = erro?.message ?? erro?.root?.message

    if (!mensagem) return null

    return <p className="text-xs text-error my-auto">{mensagem}</p>
}
